import { Box, BoxProps, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

import { rgba } from 'polished';

import React, { FC, useEffect, useRef, useState } from 'react';

const Wrapper = styled(Box)`
  position: relative;
  height: inherit;
`;

const InnerWrapper = styled(Box)`
  overflow-y: auto;
`;

const Overlay = styled(Box)<{ visible?: boolean }>`
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  height: 80px;
  opacity: ${(props): number => (props.visible ? 0 : 0.9)};
  pointer-events: none;
  transition: all 0.1s linear;
`;

const ScrollableWithGradient: FC<BoxProps> = ({ children, ...rest }) => {
  const { colors } = useTheme();
  const [isGradientVisible, setIsGradientVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && ref.current?.scrollHeight <= ref.current.clientHeight) {
      setIsGradientVisible(true);
    }
  }, []);

  const handleScroll = (event: React.UIEvent<HTMLDivElement>): void => {
    const target = event.target as HTMLDivElement;

    if (target.scrollHeight - target.scrollTop - 5 <= target.clientHeight) {
      setIsGradientVisible(true);
    } else {
      setIsGradientVisible(false);
    }
  };

  return (
    <Wrapper onScroll={handleScroll}>
      <InnerWrapper ref={ref} {...rest}>
        {children}
      </InnerWrapper>
      <Overlay visible={isGradientVisible} bg={`linear-gradient(180deg, ${rgba(colors.white, 0)} 0%, ${colors.white} 100%)`} />
    </Wrapper>
  );
};

export default ScrollableWithGradient;
